
export interface SseEvent {
    event: string;
    data: any;
}

/**
 * Service that helps with parsing stream data chunks into bound model (SseEvent)
 */
export class SseParser {

    private buffer: string = "";

    /** Feed a decoded chunk; returns every event completed by it. */
    public push( chunk: string ): SseEvent[] {
        this.buffer = (this.buffer + chunk).replace(/\r\n/g, "\n");
        let events: SseEvent[] = [];
        let idx = this.buffer.indexOf("\n\n");
        while ( idx !== -1 ) {
            let block = this.buffer.slice(0, idx);
            this.buffer = this.buffer.slice(idx + 2);
            let parsed = SseParser.parseBlock(block);
            if ( parsed !== null ) {
                events.push(parsed);
            }
            idx = this.buffer.indexOf("\n\n");
        }
        return events;
    }

    /** Emit a final unterminated block, if the stream ended mid-event. */
    public flush(): SseEvent[] {
        let rest = this.buffer.trim();
        this.buffer = "";
        if ( rest === "" ) {
            return [];
        }
        let parsed = SseParser.parseBlock(rest);
        return parsed === null ? [] : [parsed];
    }

    private static parseBlock( block: string ): SseEvent | null {
        let name: string = "message";
        let dataLines: string[] = [];
        let sawField: boolean = false;

        block.split("\n").forEach( (line: string) => {
            if ( line.trim() === "" || line.startsWith(":") ) {
                return;
            }
            let sep = line.indexOf(":");
            let field = sep === -1 ? line.trim() : line.slice(0, sep).trim();
            let value = sep === -1 ? "" : line.slice(sep + 1);
            if ( value.startsWith(" ") ) {
                value = value.slice(1);
            }
            value = SseParser.unquote(value.trim());
            if ( field === "event" ) {
                name = value;
                sawField = true;
            } else if ( field === "data" ) {
                dataLines.push(value);
                sawField = true;
            }
        } );

        if ( !sawField ) {
            return null;
        }

        if ( dataLines.length === 0 ) {
            return { event: name, data: null };
        }

        let raw = dataLines.join("\n");
        let data: any = raw;
        try {
            data = JSON.parse(raw);
        } catch ( e ) {
            data = raw;
        }
        return { event: name, data: data };
    }

    /**
     * Data has "'" maybe we should fix this in the API 
     * at some point 
     */
    private static unquote( value: string ): string {
        if ( value.length > 1 ) {
            let first = value.charAt(0);
            let last = value.charAt(value.length - 1);
            if ( first === "'" && last === "'" ) {
                return value.slice(1, -1);
            }
        }
        return value;
    }
}
